import React from 'react';

import { AlertCompletion, CocEmail } from '@/apis/types';

import Pill from '../AiTranscripts/ui/Pill';
import { useEmailReplyT } from '../AiTranscripts/emailComposer/emailReplyStrings';
import styles from './cocEmailEntry.module.css';

/**
 * The per-email fields of an inbound email entry, or undefined for every other
 * entry and for companies without the feature (no `email` key at all).
 */
export function getInboundEmail(
  completion: AlertCompletion
): CocEmail | undefined {
  return completion.email?.entry_type === 'inbound'
    ? completion.email
    : undefined;
}

/** Needs attention (orange) and Reply needed (blue), only on unanswered emails. */
export const CocEmailBadges: React.FC<{ email: CocEmail }> = ({ email }) => {
  const { t } = useEmailReplyT();
  if (!email.needs_reply) return null;
  return (
    <span data-testid='coc-email-badges' className={styles.badges}>
      <Pill variant='needs_attention'>{t('needsAttention')}</Pill>
      <Pill variant='reply_needed'>{t('replyNeeded')}</Pill>
    </span>
  );
};
